import React from 'react'
import moment from 'moment'
import PropTypes from 'prop-types'
import classNames from 'classnames'

export const MemberUntilDateEditor = ({
  date,
  expired,
  editMode,
  onDateChange,
}) => {
  return (
    <div>
      {editMode ? (
        <wb-datepicker-control>
          <wb-input-control class="memberUntilDateSelector">
            <wb-input>
              <label htmlFor="dateSelector">Choose Date</label>
              <input
                type="date"
                id="dateSelector"
                value={date}
                onChange={(e) => onDateChange(e.target.value)}
                min={moment().format('YYYY-MM-DD')}
                max={moment().add(90, 'days').format('YYYY-MM-DD')}
              />
            </wb-input>
          </wb-input-control>
        </wb-datepicker-control>
      ) : (
        <div
          className={classNames({
            'tenant-members--user-expired': expired,
          })}
        >
          {date}
        </div>
      )}
    </div>
  )
}

MemberUntilDateEditor.propTypes = {
  date: PropTypes.string,
  expired: PropTypes.bool,
  editMode: PropTypes.bool,
  onDateChange: PropTypes.func,
}
